import React from 'react';
import './Founder.css'
function Founder() {
    return (
        <div className='container founder text-center '>
                <h2 className=''>Message From <span style={{ color: '#f5526f' }}>The Founder</span> </h2>
            
                <img className='border rounded-circle ' src='https://pbs.twimg.com/profile_images/1468854174871863303/2ZcYygsM_400x400.jpg' alt="" srcset="" />
                <p className=''>"<span style={{ color: '#f5526f' }}>If you focus on quantity our quality so you will make profits in short term</span> but in the long run
                    Your way to go home will be easier. "
                </p>
            
        </div>
    )
}

export default Founder
